import React from 'react';
import { Link } from 'react-router-dom';
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import EmptyListUI from '../../../widgets/output/EmptyListUI';
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI';
import IconButtonUI from '../../../widgets/action/IconButtonUI';
import NachFailureRecordsListUI from './NachFailureRecordsListUI';
import NachFailureUpdateModalSF from '../../../pages/superUser/account/NachFailureUpdateModalSF';

const NachFailureRecordsPageUI = ({
  context,
  errorList,
  nachFailureList,
  account,
  yearMonth,
  onPreviousClick,
  onNextClick,
  onRefreshClick, onUpdateClick, onCancelClick, updateMode
}) => (
  <SuperUserAccountPageUI
    context={context}
    className='pg_su_acc'
    backLink='/su/accounts'
    headerText={account ? account.accountName : ''}
    dimension='w768'
    centered={!account}
    account={account}
    page='nachFailures'
  >
    {(!account || !errorList) && <SpinnerComponentUI />}

    {/* {nachFailureList && ( */}
    <LRTableActionsUI
      location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <span className='g_flex_left g_flex_v'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            {yearMonth && (
              <span className='g_m_left_100 g_large'>
                <b>NACH Failures, {yearMonth.monthName} {yearMonth.year}</b>
              </span>
            )}
            <Link to='/su/monitoringIntelligence' className='g_m_left_50 g_m_top_100 g_link'>
              Monitoring Intelligence
            </Link>
          </span>

        </span>
      }
      right={
        <span className='g_text_right'>
          <div className='g_flex_h g_flex_right'>
            <span className='g_m_left_100' />
            <Link to='#' onClick={onPreviousClick}>Previous</Link>
            <span className='g_m_left_100' />
            <Link to='#' onClick={onNextClick}>Next</Link>
          </div>
        </span>
      }
    />
    {/* )} */}

    {nachFailureList && nachFailureList.length > 0 && (
      <NachFailureRecordsListUI
        context={context}
        records={nachFailureList}
        onUpdateClick={onUpdateClick}
      />
    )}

    {(!nachFailureList || nachFailureList.length === 0) && (
      <EmptyListUI
        context={context}
        createDisabledMessageLabel='No NACH Failure Records'
      />
    )}
    <NachFailureUpdateModalSF
      context={context}
      account={account}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onRefreshClick={onRefreshClick}
    />
  </SuperUserAccountPageUI>
);

export default NachFailureRecordsPageUI;
